import {ReactElement} from "react";
import {IFormulaBarUpdates} from "../../../../../../../contexts/account/data/useFormulaBarUpdates";
import {Button} from "@zendeskgarden/react-buttons";
import css from "../styles/operationalDriverMenu.module.scss";
import {DriverMetricsMapObject} from "../../../logic/useFormulaBarMenu";
import {titleCase} from "../../../../../../../global/string_functions";
import {DriverOperationalAverageMetric} from "../../../../../../../__generated__/generated_types";
import {Property} from "../../../../../../../contexts/properties/logic";
import {useProperties} from "../../../../../../../contexts/properties/PropertiesContext";


export interface IOperationalMonthlyAverageDriverMenu {
    fbUpdates: IFormulaBarUpdates;
    menuOptions: DriverMetricsMapObject[];
    handleCloseParent: () => void;
}

export default function OperationalMonthlyAverageDriverMenu({
    fbUpdates,
    handleCloseParent,
    menuOptions
}: IOperationalMonthlyAverageDriverMenu): ReactElement {
    function saveDriver(metric: string, property: Property) {
        let startMonth = "2025-01-01";
        let endMonth = "2025-02-01";
        if(property) {
            if(property.isAcquisitionProperty) {
                startMonth = `${property.reforecastYear - 1}-11-01`;
                endMonth = `${property.reforecastYear - 1}-12-01`;
            } else {
                let month = property.reforecastStartMonthIndex - 1;
                let year = property.reforecastYear;
                if(month < 0) {
                    month = 11;
                    year -= 1;
                }
                endMonth = `${year}-${(month + 1).toString(10).padStart(2, "0")}-01`;

                month -= 1;
                if(month < 0) {
                    month = 11;
                    year -= 1;
                }
                startMonth = `${year}-${(month + 1).toString(10).padStart(2, "0")}-01`;
            }
        }

        fbUpdates.addOperationalMonthlyAverageDriver({
            sourceMetric: metric as DriverOperationalAverageMetric,
            locked: false,
            startMonth: startMonth,
            endMonth: endMonth,
            monthlyGrowth: undefined,
            yearlyGrowth: undefined
        });
        handleCloseParent();
    }

    // TODO: Remove this as soon as possible.
    const {currentProperty} = useProperties();

    return <ul className={css.menuWrapper}>
        <li>
            <h4 className={css.header}>Op Month Avg Drivers</h4>
        </li>
        {currentProperty ?
            menuOptions.map(opt =>
                    <li key={opt.value}>
                        <Button isBasic onClick={() => saveDriver(opt.value, currentProperty)}>{titleCase(opt.name.split("_").join(" "))}</Button>
                    </li>
            ) :
            <li>
                Not Available.
            </li>
        }
    </ul>;
}
